import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {serialize} from "../../../helpers/utils/Utils";

// @ts-ignore
export const codeApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchCode: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-code?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['codes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCodesList: build.query({
            query: () => {
                return {
                    url: `/ajax/get-all-codes`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['codesList'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCodeById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-code-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['codeById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createCode: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/code`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['codes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Code");
            },
        }),
        updateCode: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/code/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['codes', 'codeById', 'userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Code")
            },
        }),

        deleteCodeById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/code/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['codes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Code");
            },
        }),

    }),
});


export const {
    useGetCodeByIdQuery,
    useUpdateCodeMutation,
    useSearchCodeQuery,
    useDeleteCodeByIdMutation,
    useGetCodesListQuery,
    useCreateCodeMutation,
} = codeApi;